import { CREATE_API_KEY_FINISHED, DELETE_API_KEY_FINISHED, CREATE_API_KEY, REQUEST_API_KEYS_FINISHED } from "./ApiKeyActions";

export default function apiKeyReducer(state = {}, action) {
    switch (action.type){
        case REQUEST_API_KEYS_FINISHED:
            if(!action.error){
                return {
                    ...state,
                    apiKeys: action.payload,
                    error: null,
                };
            }else{
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case DELETE_API_KEY_FINISHED:
            if(!action.error){
                return {
                    ...state,
                    deleted: action.payload,
                    error: null,
                };
            }else{
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case CREATE_API_KEY:
            return {
                ...state,
                isCreatingKey: true,
        };
        case CREATE_API_KEY_FINISHED:
            if(!action.error){
                return {
                    ...state,
                    created: action.payload,
                    error: null,
                    isCreatingKey: false,
                };
            }else{
                return {
                    ...state,
                    error: action.payload,
                    isCreatingKey: false,
                };
            }
        default:
            return state;
    }
}
       